import $ from 'jquery';

export default class {
    constructor() {
        this.navItems = $('.meal-plan-nav-item');
        this.navImages = $('.step-content');
        this.carousels = $('.carousel');
        this.showNutrients = $('.meal-plan-nutrition-show');
        this.detailChevron = $('.detail-chevron');
        this.introduction = $('.meal-plan-introduction');
        this.init();
    }

    init() {
        this.navItems.on('click', this.handleNavItemSelection.bind(this));
        this.showNutrients.click(this.handleShowNutrients.bind(this));
        this.detailChevron.on('click', this.handleShowDetails.bind(this));

        $('.prep-day-carousel-indicator').click(() => {
            const $indicator = $(event.currentTarget);
            $indicator.parents('ol').children().removeClass('active');
            $indicator.addClass('active');

            const rowIdx = $indicator.data('row');
            $indicator.parents('.prep-day-recipes-desktop').children().removeClass('prep-day-row-active');
            $indicator.parents('.prep-day-recipes-desktop').children(`[data-row=${rowIdx}]`).addClass('prep-day-row-active');
        });

        $('.meal-plan-schedule-day-selector').click(() => {
            const $selector = $(event.currentTarget);
            $('.meal-plan-schedule-day-selector').removeClass('meal-plan-schedule-day-selector-active');
            $selector.addClass('meal-plan-schedule-day-selector-active');

            const selectedDay = $selector.data('day');
            this.showMealsForDay(selectedDay);
        });

        $('#day-select').change(() => {
            const day = event.target.value;
            this.showMealsForDay(day);
        });
    }

    handleNavItemSelection(event) {
        event.stopPropagation();
        const title = $(event.currentTarget).data('title');

        if ($(event.currentTarget).hasClass('selected-step')) {
            $(event.currentTarget).removeClass('selected-step')
            $(event.currentTarget).addClass('selected-step-collapsed')
            return;
        }

        // remove active states
        this.navItems.removeClass('selected-step');
        this.navItems.removeClass('selected-step-collapsed');
        this.navImages.removeClass('selected-step-media');
        this.carousels.removeClass('active');

        // account for selected nav
        $(event.currentTarget).addClass('selected-step');

        // account for images
        this.navImages.filter(function () {
            return $(this).data('title') === title;
        }).addClass('selected-step-media');

        // account for carousels
        this.carousels.filter(function () {
            return $(this).data('title') === title;
        }).addClass('active')
    }

    handleShowDetails() {
        if (this.introduction.hasClass('inactive')) {
            this.introduction.slideDown();
            this.introduction.removeClass('inactive');
        } else {
            this.introduction.slideUp();
            this.introduction.addClass('inactive');
        }

        if (this.detailChevron.hasClass('active')) {
            this.detailChevron.removeClass('active');
        } else {
            this.detailChevron.addClass('active');
        }
    }

    handleShowNutrients(event) {
        const day = $(event.currentTarget).data('day');
        $('.meal-plan-nutrients').removeClass('meal-plan-nutrients-active');
        $(`.meal-plan-nutrients[data-day=${day}]`).addClass('meal-plan-nutrients-active');
    }

    showMealsForDay(selectedDay) {
        $('.prep-day-recipes').removeClass('prep-day-recipes-active');
        $(`.prep-day-recipes[data-day=${selectedDay}]`).addClass('prep-day-recipes-active');
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/MealPlanController.js